import Layers from 'dashboard/components/GraphCanvasV2/event-bus/layers';
import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import CanvasLayer from 'dashboard/components/GraphCanvasV2/layers/canvas-layer';
import DisplayPanelLayer from 'dashboard/components/GraphCanvasV2/layers/display-panel-layer';
import HoverCardLayer from 'dashboard/components/GraphCanvasV2/layers/hover-card-layer';
import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import ReactModalsLayer from 'dashboard/components/GraphCanvasV2/layers/react-modals-layer';
import WindowLayer from 'dashboard/components/GraphCanvasV2/layers/window-layer';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
export default class WheelLayers extends Layers implements Iterable<Layer> {
  constructor(
    g6Wrapper: G6Wrapper,
    graphExplorer: GraphExplorer,
    x: number,
    y: number,
    canvasX: number,
    canvasY: number,
    canvasBBox: { top: number; right: number; bottom: number; left: number },
  ) {
    super(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox);

    this.layers = [
      new ReactModalsLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new HoverCardLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new DisplayPanelLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new CanvasLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
      new WindowLayer(g6Wrapper, graphExplorer, x, y, canvasX, canvasY, canvasBBox),
    ];
  }
}
